// extracted by mini-css-extract-plugin
export var dateHolder = "projectCard-module--dateHolder--aLSx6";
export var divider = "projectCard-module--divider--YopWn";
export var mrTp20 = "projectCard-module--mrTp20--B2u2n";
export var postCardImg = "projectCard-module--postCardImg--57E0Y";
export var projectCard = "projectCard-module--projectCard--G3VVj";
export var title = "projectCard-module--title--seeDW";